import React from "react";
import PropTypes from "prop-types";
import * as classes from "./Footer.module.css";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import { BLOCKS } from "@contentful/rich-text-types";
import { Link } from "gatsby"

const Footer = ({ footer, finnishLanguage }) => {
  const legalTexts = footer.legalTexts;

  const options = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (node, children) => {
        return <p>{children}</p>;
      }
    }
  };

  return (
    <footer>
      <div className={classes.footerRow}>
        <h4>{footer.followUs.title}</h4>
        <div className={classes.socialMedia}>
          {footer.followUs.socialMedia &&
            footer.followUs.socialMedia.map((item) => {
              return item.url? (
                <a
                  href={item.url}
                  target="_blank"
                  rel="nooperner noreferrer"
                  key={item.site}
                >
                  <img alt={item.site} src={item.icon.file.url} />
                </a>
              ) : (
                <Link to={finnishLanguage ? `/fi/${item.internalUrl.slug}` : `/${item.internalUrl.slug}`} key={item.site}>
                  <img alt={item.site} src={item.icon.file.url} />
                </Link>
              );
            })}
        </div>
      </div>
      <div className={classes.footerRow}>
        {legalTexts && renderRichText(legalTexts, options)}
      </div>
    </footer>
  );
};

Footer.propTypes = {
  footer: PropTypes.object.isRequired,
  finnishLanguage: PropTypes.bool.isRequired
};

export default Footer;
